<template>
    <div v-if="!item.hidden&&item.children" class="menu-wrapper">
        <router-link
            v-if="hasOneShowingChild(item.children) && !onlyOneChild.children&&!item.alwaysShow"
            :to="resolvePath(onlyOneChild.path)"
        >
            <el-menu-item
                :index="resolvePath(onlyOneChild.path)"
                :class="{'submenu-title-noDropdown':!isNest}"
            >
                <svg-icon
                    v-if="onlyOneChild&&onlyOneChild.iconCls"
                    :icon-class="onlyOneChild.iconCls"
                ></svg-icon>
                <span
                    v-if="onlyOneChild&&onlyOneChild.title"
                    slot="title"
                >{{generateTitle(onlyOneChild.title)}}</span>
            </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.title||item.uri">
            <template slot="title">
                <svg-icon v-if="item&&item.iconCls" :icon-class="item.iconCls"></svg-icon>
                <span
                    v-if="item&&item.title"
                    slot="title"
                >{{generateTitle(item.title)}}</span>
            </template>

            <template v-for="child in item.children" v-if="!child.hidden">
                <sidebar-item
                    :is-nest="true"
                    class="nest-menu"
                    v-if="child.children&&child.children.length>0"
                    :item="child"
                    :key="child.uri"
                    :base-path="resolvePath(child.uri)"
                ></sidebar-item>

                <router-link v-else :to="resolvePath(child.uri)" :key="child.title">
                    <el-menu-item :index="resolvePath(child.uri)" style="padding-left:45px">
                        <svg-icon
                            v-if="child&&child.iconCls"
                            :icon-class="child.iconCls"
                        ></svg-icon>
                        <span
                            v-if="child&&child.title"
                            slot="title"
                        >{{generateTitle(child.title)}}</span>
                    </el-menu-item>
                </router-link>
            </template>
        </el-submenu>
    </div>
</template>

<script>
import path from 'path';

export default {
    name: 'SidebarItem',
    props: {
        // route object
        item: {
            type: Object,
            required: true
        },
        isNest: {
            type: Boolean,
            default: false
        },
        basePath: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            onlyOneChild: null
        };
    },
    methods: {
        hasOneShowingChild(children) {
            const showingChildren = children.filter(item => {
                if (item.hidden) {
                    return false;
                }
                // temp set(will be used if only has one showing child )
                this.onlyOneChild = item;
                return true;
            });
            if (showingChildren.length === 1) {
                return true;
            }
            return false;
        },
        resolvePath(...paths) {
            return path.resolve(this.basePath, ...paths);
        },
        generateTitle(title) {
            return this.$t(title);
        }
    }
};
</script>
